import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './WrapperTemplate.scss';

// wrapDescription: optional short note under the title
export const WrapperTemplate = ({ wrapTitle, wrapDescription, children, wrapClassName }) => {
    const { t } = useTranslation();
    return (
        <>
            <h4 className={`wrap-title ${wrapClassName}`}>{t(wrapTitle)}</h4>
            {wrapDescription && <p className="wrap-description">{t(wrapDescription)}</p>}
            {children}
        </>
    );
};

WrapperTemplate.prototype = {
    wrapTitle: PropTypes.string,
    wrapDescription: PropTypes.string,
    children: PropTypes.node,
};
